import { useNavigate } from "react-router-dom"
import Rectangle17 from "@/assets/Rectangle 17.png";
import { FaArrowRight } from "react-icons/fa";

const Partner = ({ partner }) => {
    const navigate = useNavigate();

    return (
      <div className="rounded-md p-4 mt-4 flex items-start glass-header !border-white !border-2 !shadow-none gap-5">
        <div className="flex cursor-pointer flex-col gap-2">
          <div className="w-32 h-36 rounded-lg">
            <img
              className="w-full h-full"
              src={Rectangle17}
              alt="Rectangle17"
            />
          </div>
          <h3 className="text-xl text-center font-bold">
            {partner?.name?.first}
          </h3>
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col">
            <p className="text-[#6B7280] font-bold">Full Name</p>
            <p>{`${partner?.name?.first} ${partner?.name?.last}`}</p>
          </div>
          <div className="flex flex-col">
            <p className="text-[#6B7280] font-bold">Email</p>
            <p>{partner?.email}</p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col">
            <p className="text-[#6B7280] font-bold">Address</p>
            <p className="max-w-[200px]">{`${partner?.address?.addressLine} ${partner?.address?.city}, ${partner?.address?.state}, ${partner?.address?.pinCode}`}</p>
          </div>
          <button
            onClick={() =>
              navigate(`/admin/partners/${partner?._id}`, { state: partner })
            }
            className="mt-10 text-[#1A56DB] flex gap-2 items-center"
          >
            Learn more
            <FaArrowRight />
          </button>
        </div>
      </div>
    );
}

export default Partner